export default __webpack_public_path__ + "static/media/ion_duplicate-outline.4c6c53a9.svg";